var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadedHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E8EBFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20H20.75M17 23H20.75M17 26H20.75M23.75 26.75H26C27.2426 26.75 28.25 25.7426 28.25 24.5V14.1082C28.25 12.9732 27.405 12.0102 26.2739 11.9163C25.9006 11.8853 25.5261 11.8586 25.1505 11.8362M19.3495 11.8362C19.2848 12.046 19.25 12.2689 19.25 12.5C19.25 12.9142 19.5858 13.25 20 13.25H24.5C24.9142 13.25 25.25 12.9142 25.25 12.5C25.25 12.2689 25.2152 12.046 25.1505 11.8362M19.3495 11.8362C19.6328 10.9176 20.4884 10.25 21.5 10.25H23C24.0116 10.25 24.8672 10.9176 25.1505 11.8362M19.3495 11.8362C18.9739 11.8586 18.5994 11.8853 18.2261 11.9163C17.095 12.0102 16.25 12.9732 16.25 14.1082V16.25M16.25 16.25H12.875C12.2537 16.25 11.75 16.7537 11.75 17.375V28.625C11.75 29.2463 12.2537 29.75 12.875 29.75H22.625C23.2463 29.75 23.75 29.2463 23.75 28.625V17.375C23.75 16.7537 23.2463 16.25 22.625 16.25H16.25ZM14.75 20H14.7575V20.0075H14.75V20ZM14.75 23H14.7575V23.0075H14.75V23ZM14.75 26H14.7575V26.0075H14.75V26Z",
    stroke: "#120A8F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedHistory);
export default __webpack_public_path__ + "static/media/uploaded-history.774f1140d95528df52ef4baba6422f7f.svg";
export { ForwardRef as ReactComponent };